import React from 'react';

export function Card({ children, padding = '20px', spotlight = false, style, ...rest }) {
  return (
    <div
      style={{
        background: spotlight ? 'var(--highlight)' : 'var(--surface-1)',
        color: spotlight ? 'var(--highlight-ink)' : 'inherit',
        border: '1px solid ' + (spotlight ? 'var(--highlight)' : 'var(--border)'),
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-md)',
        padding,
        overflow: padding === '0' || padding === 0 ? 'hidden' : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, bare = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingBottom: bare ? 0 : '16px', marginBottom: bare ? 0 : '16px', borderBottom: bare ? 'none' : '1px solid var(--border)' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', flex: 1, minWidth: 0 }}>
        <h3 style={{ fontSize: 'var(--fs-display-sm)', fontWeight: 600 }}>{title}</h3>
        {subtitle && <span style={{ fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)' }}>{subtitle}</span>}
      </div>
      {action}
    </div>
  );
}
